var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkOvalFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.2071 11.2071C16.5976 10.8166 16.5976 10.1834 16.2071 9.79289C15.8166 9.40237 15.1834 9.40237 14.7929 9.79289L11.0466 13.5392L9.75073 12.0666C9.38587 11.652 8.75399 11.6117 8.33938 11.9766C7.92478 12.3414 7.88444 12.9733 8.2493 13.3879L10.2493 15.6606C10.4318 15.868 10.692 15.9907 10.9681 15.9995C11.2443 16.0083 11.5118 15.9025 11.7071 15.7071L16.2071 11.2071Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOvalFilled);
export default __webpack_public_path__ + "static/media/Checkmark-Oval-Filled.3c692eed39d5db71f60a681412d8aafd.svg";
export { ForwardRef as ReactComponent };